import React from 'react';

const ZwalletGuide = () => {
  return (
    <div className="help-section">
      <div className="section-header">
        <div className="icon">🏦</div>
        <h2>Zwallet Complete Guide</h2>
      </div>
      
      <div className="info-card">
        <h3>Proprietary Wallet System</h3>
        <p>Zwallet is our exclusive wallet solution. No third-party wallets (MetaMask, Coinbase, etc.) are supported.</p>
      </div>
      
      <div className="section-grid">
        <div className="info-card">
          <h3>Security Features</h3>
          <ul style={{ color: 'var(--text-secondary)', paddingLeft: '20px' }}>
            <li>PBKDF2 Key Derivation (100,000 iterations)</li>
            <li>AES-256 Bank-level encryption</li>
            <li>Unique salt per user</li>
            <li>Memory-only password storage</li>
            <li>30-minute auto-logout</li>
          </ul>
        </div>
        
        <div className="info-card">
          <h3>Wallet Functions</h3>
          <ul style={{ color: 'var(--text-secondary)', paddingLeft: '20px' }}>
            <li>Send/receive ETH and ERC-20 tokens</li>
            <li>Real-time portfolio tracking</li>
            <li>Transaction history</li>
            <li>ENS name integration</li>
            <li>Gas price optimization</li>
          </ul>
        </div>
      </div>
      
      <div className="warning-box">
        <h4><span>🔒</span> Security Warning</h4>
        <p style={{ color: 'var(--text-light)', margin: 0 }}>
          Zpost cannot recover lost seed phrases. Store them securely in multiple locations. Never share your seed phrase with anyone.
        </p>
      </div>
    </div>
  );
};

export default ZwalletGuide;
